import { ReportingShellLoaderBaseConfig } from '../../../base';
import { InsertOverlayRootLoader } from './insertOverlaylInterface';
import { InsertOverlayAggregate } from './insertOverlayModel';

export function createInsertOverlayLoader(
    config: ReportingShellLoaderBaseConfig
): InsertOverlayRootLoader {
    const {
        repository,
        kernel: {
            infra: { formatter },
        },
    } = config;

    return {
        useLoad(context, props): InsertOverlayAggregate {
            return {};
        },
    };
}
